module.exports = __webpack_public_path__ + "img/tsutomu-kamohara.6446ec88.jpg";